<template>
  <div>
    <div>
      <div class="row">
        <div class="col-md-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {{ $t("verifactu2") }}
              </li>
            </ol>
          </nav>
        </div>


        <div class="presentation-header">
          <h2 class="presentation-title">{{ $t('bienvenidoA') }}</h2>
          <img src="static/img/verifactu-logo.png" alt="Verifactu Logo" class="verifactu-logo" />
        </div>

        <!-- Aviso de necesidad de seleccionar un negocio -->
        <div class="col-md-12" v-if="!idBusiness">
          <div class="instruction-section mb-1">
            <div class="alert alert-info d-flex align-items-center">
              <i class="fas fa-info-circle mr-3"></i>
              <span v-html="$t('paraComenzarVerifactuSeleccionaNegocio')"></span>
            </div>
          </div>
        </div>

        <!-- Alerta de certificado expirado o proximo a expirar (el de la parte superior) -->
        <div class="col-md-12" v-if="idBusiness && step === 6">
          <div class="instruction-section mb-1">
            <div
              v-if="certificateExpired"
              class="alert d-flex align-items-center"
              style="background: linear-gradient(90deg, #f8d7da 80%, #f5c6cb 100%); border: 2px solid #dc3545; color: #721c24; box-shadow: 0 6px 18px rgba(220, 53, 69, 0.15), 0 1.5px 4px rgba(0, 0, 0, 0.07);"
            >
              <i class="fas fa-exclamation-triangle mr-3" style="font-size: 24px;"></i>
              <span v-html="$t('certificadoExpiradoAlerta')"></span>
            </div>
            <div
              v-else-if="certificateAboutToExpire"
              class="alert d-flex align-items-center"
              style="background: linear-gradient(90deg, #fff3cd 80%, #ffe8a1 100%); border: 2px solid #ffc107; color: #856404; box-shadow: 0 6px 18px rgba(255, 193, 7, 0.15), 0 1.5px 4px rgba(0, 0, 0, 0.07);"
            >
              <i class="fas fa-exclamation-triangle mr-3" style="font-size: 24px;"></i>
              <span v-html="$t('certificadoProximoExpirarAlerta')"></span>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="card">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="listBusiness">{{ $t("negocio") }}</label>
                  <div class="business-select-wrapper">
                    <el-select class="select-default" size="large" v-model="idBusiness" filterable
                      :placeholder="$t('seleccionarNegocio')">
                      <el-option v-for="business in businesses" class="select-primary" :value="business.id"
                        :label="business.establishmentName" :key="business.id">
                        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                          <span>{{ business.establishmentName }}</span>
                          <span style="display: flex; align-items: center; margin-left: 10px;">
                            <i v-if="business.statusVerifactu === 'expirado'"
                               class="fas fa-exclamation-circle"
                               style="color: #ff4444; font-size: 16px; animation: pulse 2s infinite;"></i>
                            <i v-else-if="business.statusVerifactu === 'expira_pronto'"
                               class="fas fa-exclamation-triangle"
                               style="color: #ffaa00; font-size: 16px; animation: pulse 2s infinite;"></i>
                            <i v-else-if="business.statusVerifactu === 'sin_configurar'"
                               class="fas fa-info-circle"
                               style="color: #66aaff; font-size: 16px;"></i>
                            <i v-else-if="business.statusVerifactu === 'configurado'"
                               class="fas fa-check-circle"
                               style="color: #28a745; font-size: 16px;"></i>
                            <i v-else-if="business.statusVerifactu === 'exento'"
                               class="fas fa-minus-circle"
                               style="color: #6c757d; font-size: 16px;"></i>
                          </span>
                        </div>
                      </el-option>
                    </el-select>
                    <span v-if="selectedBusiness" class="business-status-icon" style="margin-right: 5px;">
                      <i v-if="selectedBusiness.statusVerifactu === 'expirado'"
                         class="fas fa-exclamation-circle"
                         style="color: #ff4444; font-size: 16px; animation: pulse 2s infinite;"></i>
                      <i v-else-if="selectedBusiness.statusVerifactu === 'expira_pronto'"
                         class="fas fa-exclamation-triangle"
                         style="color: #ffaa00; font-size: 16px; animation: pulse 2s infinite;"></i>
                      <i v-else-if="selectedBusiness.statusVerifactu === 'sin_configurar'"
                         class="fas fa-info-circle"
                         style="color: #66aaff; font-size: 16px;"></i>
                      <i v-else-if="selectedBusiness.statusVerifactu === 'configurado'"
                         class="fas fa-check-circle"
                         style="color: #28a745; font-size: 16px;"></i>
                      <i v-else-if="selectedBusiness.statusVerifactu === 'exento'"
                         class="fas fa-minus-circle"
                         style="color: #6c757d; font-size: 16px;"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-8" style="display: flex; justify-content: flex-end; align-items: center;">
                <div class="declaraciones-dropdown">
                  <el-dropdown>
                    <el-button type="primary" size="large">
                      <i class="fa fa-file-pdf mr-1"></i>
                      {{ $t("declaracionesResponsables") }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <a :href="getPdfUrl('Declaración de uso de certificado digital.pdf')" target="_blank">
                        <el-dropdown-item class="text-danger">
                          <strong><i class="fa fa-file-pdf"></i> Declaración de uso de certificado digital</strong>
                        </el-dropdown-item>
                      </a>
                      <a :href="getPdfUrl('Declaración Responsable - Numier TPV.pdf')" target="_blank">
                        <el-dropdown-item class="text-danger">
                          <strong><i class="fa fa-file-pdf"></i> Declaración Responsable - TPV</strong>
                        </el-dropdown-item>
                      </a>
                      <a :href="getPdfUrl('Declaración Responsable - Numier FACTURA QR.pdf')" target="_blank">
                        <el-dropdown-item class="text-danger">
                          <strong><i class="fa fa-file-pdf"></i> Declaración Responsable - FACTURA QR</strong>
                        </el-dropdown-item>
                      </a>
                      <a :href="getPdfUrl('Declaración Responsable - Numier COMERCIO.pdf')" target="_blank">
                        <el-dropdown-item class="text-danger">
                          <strong><i class="fa fa-file-pdf"></i> Declaración Responsable - COMERCIO</strong>
                        </el-dropdown-item>
                      </a>
                      <a :href="getPdfUrl('Declaración Responsable - Numier KIOSCO.pdf')" target="_blank">
                        <el-dropdown-item class="text-danger">
                          <strong><i class="fa fa-file-pdf"></i> Declaración Responsable - KIOSCO</strong>
                        </el-dropdown-item>
                      </a>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>





        <div class="col-md-12 main-content">

          <div class="certificate-info-card main-card">

            <!-- Contenido cuando NO hay negocio seleccionado -->
            <div v-if="!idBusiness" class="verifactu-presentation">

              <div class="presentation-content">


                <div class="benefits-section">

                  <h3 class="benefits-title">{{ $t('informacionSobreVerifactu') }}</h3>

                  <p class="presentation-description" v-html="$t('verifactuDescripcion')"> </p>

                  <div class="benefits-grid">
                    <div class="benefit-card">
                      <div class="benefit-icon">
                        <i class="fas fa-robot"></i>
                      </div>
                      <div class="benefit-content">
                        <h4>{{ $t('automatizacionInteligente') }}</h4>
                        <p>{{ $t('automatizacionInteligenteDesc') }}</p>
                        <small class="benefit-detail">{{ $t('automatizacionInteligenteDetalle') }}</small>
                        <span class="benefit-stat">{{ $t('automatizacionInteligenteStat') }}</span>
                      </div>
                    </div>

                    <div class="benefit-card">
                      <div class="benefit-icon">
                        <i class="fas fa-shield-alt"></i>
                      </div>
                      <div class="benefit-content">
                        <h4>{{ $t('cumplimientoNormativo') }}</h4>
                        <p>{{ $t('cumplimientoNormativoDesc') }}</p>
                        <small class="benefit-detail">{{ $t('cumplimientoNormativoDetalle') }}</small>
                        <span class="benefit-stat">{{ $t('cumplimientoNormativoStat') }}</span>
                      </div>
                    </div>

                    <div class="benefit-card">
                      <div class="benefit-icon">
                        <i class="fas fa-search-plus"></i>
                      </div>
                      <div class="benefit-content">
                        <h4>{{ $t('controlDeCalidad') }}</h4>
                        <p>{{ $t('controlDeCalidadDesc') }}</p>
                        <small class="benefit-detail">{{ $t('controlDeCalidadDetalle') }}</small>
                        <span class="benefit-stat">{{ $t('controlDeCalidadStat') }}</span>
                      </div>
                    </div>

                    <div class="benefit-card">
                      <div class="benefit-icon">
                        <i class="fas fa-lock"></i>
                      </div>
                      <div class="benefit-content">
                        <h4>{{ $t('seguridadAvanzada') }}</h4>
                        <p>{{ $t('seguridadAvanzadaDesc') }}</p>
                        <small class="benefit-detail">{{ $t('seguridadAvanzadaDetalle') }}</small>
                        <span class="benefit-stat">{{ $t('seguridadAvanzadaStat') }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Aviso sobre exencion SII -->
                <div class="sii-exemption-notice">
                  <div class="notice-icon">
                    <i class="fas fa-info-circle"></i>
                  </div>
                  <div class="notice-content">
                    <h4>{{ $t('importanteEmpresasSII') }}</h4>
                    <p>
                      {{ $t('siTuEmpresaEstaAdscritaSII') }}
                      <a href="https://sede.agenciatributaria.gob.es/Sede/iva/sistemas-informaticos-facturacion-verifactu/cuestiones-generales/quienes-estan-obligados-que-operaciones-incluyen.html"
                        target="_blank" rel="noopener noreferrer" class="notice-link">
                        {{ $t('masInformacionAqui') }}
                        <i class="fas fa-external-link-alt"></i>
                      </a>
                    </p>
                  </div>
                </div>

              </div>


            </div>

            <!-- Contenido cuando YA hay seleccionado -->
            <div v-else>

              <!-- Paso 1: Informacion y boton de certificado -->
              <div v-if="step === 1" class="step-1-container">

                <div class="certificate-header">
                  <div class="icon-circle icon-certificate certificate-icon">
                    <i class="fas fa-certificate"></i>
                  </div>
                  <div class="certificate-title icon-title">
                    <h3>{{ $t('configuracionDeVerifactu') }}</h3>
                    <p class="subtitle">{{ negocioNombre }}</p>
                  </div>
                </div>

                <!-- Selección de fecha de inicio (aparece primero) -->
                <div v-if="!verifactuDateSelected" class="start-date-selector">

                  <div class="selector-header">
                    <i class="fas fa-calendar-check" style="font-size: 32px;"></i>
                    <h4>{{ $t('cuandoDebeComenzarTuNegocio') }}</h4>
                  </div>

                  <div class="selector-info">
                    <p>{{ $t('antesDeConfigurarDebesIndicar') }}</p>
                    <a href="https://sede.agenciatributaria.gob.es/Sede/todas-noticias/2025/abril/2/modificacion-reglamento-que-regula-sistemas-facturacion.html"
                      target="_blank" class="info-link">
                      <i class="fas fa-external-link-alt"></i>
                      {{ $t('consultarInformacionOficial') }}
                    </a>
                  </div>

                  <div class="date-options-grid">

                    <div class="date-option-card" @click="seleccionarFechaInicio('enero')">
                      <div class="option-badge badge-enero">
                        <i class="fas fa-calendar"></i>
                      </div>
                      <h5>1 de Enero de 2026</h5>
                      <p class="option-description">{{ $t('paraContribuyentesSociedades') }}</p>
                      <div class="option-footer">
                        <span class="btn-select">{{ $t('seleccionar') }}</span>
                      </div>
                    </div>

                    <div class="date-option-card" @click="seleccionarFechaInicio('julio')">
                      <div class="option-badge badge-julio">
                        <i class="fas fa-calendar-alt"></i>
                      </div>
                      <h5>1 de Julio de 2026</h5>
                      <p class="option-description">{{ $t('restoNegociosAutonomos') }}</p>
                      <div class="option-footer">
                        <span class="btn-select">{{ $t('seleccionar') }}</span>
                      </div>
                    </div>

                    <div class="date-option-card card-exento" @click="seleccionarFechaInicio('exento')">
                      <div class="option-badge badge-exento">
                        <i class="fas fa-shield-alt"></i>
                      </div>
                      <h5>{{ $t('estoyExentoSII') }}</h5>
                      <p class="option-description">{{ $t('miNegocioAdscritoSII') }}</p>
                      <div class="option-footer">
                        <span class="btn-select">{{ $t('seleccionar') }}</span>
                      </div>
                    </div>

                  </div>

                </div>

                <!-- Resto del contenido -->
                <div v-else>

                  <!-- ESTO ES BASICAMENTE STEP === 2 -->

                  <!-- Resumen de seleccion de fecha -->
                  <div class="selected-date-banner">
                    <div class="banner-content">
                      <i class="fas fa-check-circle"></i>
                      <div>
                        <strong>{{ $t('fechaInicioSeleccionada') }}:</strong>
                        <span v-if="selectedStartOption === 'enero'"> 1 de Enero de 2026</span>
                        <span v-else-if="selectedStartOption === 'julio'"> 1 de Julio de 2026</span>
                        <span v-else-if="selectedStartOption === 'exento'"> {{ $t('exentoSII') }}</span>
                      </div>
                    </div>
                    <button class="btn-change-date" @click="cambiarFechaSeleccionada">
                      <i class="fas fa-edit"></i>
                      {{ $t('cambiar') }}
                    </button>
                  </div>

                  <!-- Si NO es exento, muestra el contenido del certificado -->
                  <div v-if="selectedStartOption !== 'exento'">

                    <!-- Version MOVIL: Seccion de subida de certificado (aparece primero) -->
                    <div class="certificate-upload-mobile" id="certificate-upload-mobile">

                      <div class="mobile-separator-top"></div>

                      <div class="action-section">
                        <div v-if="!showUploader">
                          <p class="action-text">{{ $t('yaTienesCertificadoListo') }}</p>
                          <small class="action-subtitle">{{ $t('hazClickAbrirSelector') }}</small>
                          <button class="btn-certificate" @click="solicitarVerifactu">
                            <i class="fas fa-certificate"></i>
                            <span>{{ $t('tengoUnCertificado') }}</span>
                            <i class="fas fa-arrow-right"></i>
                          </button>
                        </div>

                        <div v-else class="uploader-section">
                          <div class="upload-area" @click="triggerFileInput">
                            <input ref="fileInputMobile" type="file" @change="handleFileUpload" accept=".pfx,.p12"
                              style="display: none;" />

                            <div v-if="!selectedFile" class="upload-prompt">
                              <i class="fas fa-cloud-upload-alt"></i>
                              <p>{{ $t('hazClickSeleccionarCertificado') }}</p>
                              <small>{{ $t('formatosMaximo') }}</small>
                            </div>

                            <div v-else class="file-selected">
                              <i class="fas fa-cloud-upload-alt"></i>
                              <p>{{ $t('hazClickSeleccionarCertificado') }}</p>

                              <div class="file-info-selected">
                                <p class="file-details">{{ selectedFile.name.toUpperCase() }} - {{
                                  formatFileSize(selectedFile.size) }}</p>
                              </div>

                              <button class="btn-upload" @click.stop="enviarCertificado">
                                <i class="fas fa-upload" style="color: #fff;"></i> {{ $t('subirCertificado') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mobile-separator-bottom"></div>
                    </div>

                    <div class="certificate-content">
                      <div class="info-section">
                        <div class="info-item">
                          <i class="fas fa-info-circle text-primary"></i>
                          <span v-html="$t('paraComenzarNecesitasCertificado')"></span>
                        </div>
                        <div class="info-item">
                          <i class="fas fa-shield-alt text-success"></i>
                          <span>{{ $t('certificadoPermiteAutenticacion') }}</span>
                        </div>
                        <div class="info-item">
                          <i class="fas fa-tools text-warning"></i>
                          <span v-html="$t('formatosSoportados')"></span>
                        </div>

                        <div class="certificate-help-section">
                          <div class="help-divider">
                            <span>{{ $t('aunNoTienesCertificado') }}</span>
                          </div>

                          <div class="info-item help-item">
                            <div class="help-meta">
                              <i class="fas fa-external-link-alt text-info"></i>
                              <div class="meta-text">
                                <span>{{ $t('puedesObtenerCertificadoEn') }}</span>
                              </div>
                            </div>

                            <div class="meta-action">
                              <a href="https://www.sede.fnmt.gob.es/certificados/persona-fisica" target="_blank"
                                rel="noopener noreferrer" class="certificate-link">
                                <i class="fas fa-globe"></i>
                                {{ $t('fabricaNacionalMonedaTimbre') }}
                                <i class="fas fa-external-link-alt"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mobile-separator" id="desktop-separator"></div>

                      <!-- Version ESCRITORIO: Seccion de subida de certificado (aparece a la derecha en escritorio) -->
                      <div class="action-column" id="certificate-upload-desktop">

                        <div class="action-section">

                          <div v-if="!showUploader">
                            <p class="action-text">{{ $t('yaTienesCertificadoListo') }}</p>
                            <small class="action-subtitle">{{ $t('hazClickAbrirSelector') }}</small>
                            <button class="btn-certificate" @click="solicitarVerifactu">
                              <i class="fas fa-certificate"></i>
                              <span>{{ $t('tengoUnCertificado') }}</span>
                              <i class="fas fa-arrow-right"></i>
                            </button>
                          </div>

                          <div v-else class="uploader-section">

                            <div class="upload-area" @click="triggerFileInput">

                              <input ref="fileInput" type="file" @change="handleFileUpload" accept=".pfx,.p12"
                                style="display: none;" />

                              <div v-if="!selectedFile" class="upload-prompt">
                                <i class="fas fa-cloud-upload-alt"></i>
                                <p>{{ $t('hazClickSeleccionarCertificado') }}</p>
                                <small>{{ $t('formatosMaximo') }}</small>
                              </div>

                              <div v-else class="file-selected">

                                <i class="fas fa-cloud-upload-alt"></i>
                                <p>{{ $t('hazClickSeleccionarCertificado') }}</p>

                                <div class="file-info-selected">
                                  <p class="file-details">{{ selectedFile.name.toUpperCase() }} - {{
                                    formatFileSize(selectedFile.size) }}</p>
                                </div>

                                <button class="btn-upload" @click.stop="enviarCertificado">
                                  <i class="fas fa-upload" style="color: #fff;"></i> {{ $t('subirCertificado') }}
                                </button>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Si ES exento, muestra mensaje informativo -->
                  <div v-else class="exento-info-section">
                    <div class="exento-card">
                      <div class="exento-icon">
                        <i class="fas fa-check-circle"></i>
                      </div>
                      <h3>{{ $t('negocioExentoVerifactu') }}</h3>
                      <p>{{ $t('tuNegocioNoRequiereVerifactu') }}</p>
                      <div class="exento-details">
                        <p><i class="fas fa-info-circle"></i> {{ $t('alEstarEnSIINoNecesitas') }}</p>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

              <div v-if="showAlert" class="col-md-12 alert alert-danger">
                {{ $t("debeSeleccionarUnNegocioParaSolicitarVerifactu") }}
              </div>

              <!-- Paso 4: Certificado guardado -->
              <div v-if="step === 4" class="step-4-container">

                <div class="success-header">
                  <div class="success-icon-container">
                    <div class="icon-circle icon-success success-icon-bg">
                      <i class="fas fa-certificate"></i>
                    </div>
                    <div class="success-checkmark">
                      <i class="fas fa-check"></i>
                    </div>
                  </div>
                  <div class="success-title icon-title">
                    <h3>{{ $t('certificadoConfiguradoCorrectamente') }}</h3>
                    <p class="subtitle">{{ negocioNombre }}</p>
                  </div>
                </div>

                <!-- Informacion de validez del certificado -->
                <div v-if="verifactuFechaError" class="alert alert-danger certificate-validity-info"
                  style="border: 2px solid #dc3545;">
                  <i class="fas fa-exclamation-triangle mr-2"></i>
                  <span>{{ $t('noSeHaPodidoVerificarFecha') }}</span>
                </div>
                <div v-else-if="certificateValidTo" class="alert alert-info certificate-validity-info"
                  style="border: 2px solid #17a2b8;">
                  <i class="fas fa-calendar-check mr-2"></i>
                  <span>{{ $t('certificadoValidoHasta') }}: <strong>{{ formattedCertificateValidTo }}</strong></span>
                </div>

                <div class="success-content">
                  <div class="success-info">
                    <div class="info-row">
                      <div class="info-item-success">
                        <i class="fas fa-certificate text-success"></i>
                        <span>{{ $t('certificadoValidadoConfigurado') }}</span>
                      </div>
                      <div class="info-item-success">
                        <i class="fas fa-shield-alt text-success"></i>
                        <span>{{ $t('facturasComplianNormativa') }}</span>
                      </div>
                      <div class="info-item-success">
                        <i class="fas fa-sync-alt text-success"></i>
                        <span>{{ $t('sistemaListoVerificacion') }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="success-actions">
                    <div class="actions-header">
                      <h4>{{ $t('comoFuncionaVerifactu') }}</h4>
                    </div>
                    <div class="actions-grid">
                      <div class="action-item">
                        <div class="action-icon">
                          <i class="fas fa-magic"></i>
                        </div>
                        <div class="action-content">
                          <h5>{{ $t('generacionAutomatica') }}</h5>
                          <p>{{ $t('generacionAutomaticaDesc') }}</p>
                        </div>
                      </div>
                      <div class="action-item">
                        <div class="action-icon">
                          <i class="fas fa-qrcode"></i>
                        </div>
                        <div class="action-content">
                          <h5>{{ $t('codigoQRenTickets') }}</h5>
                          <p>{{ $t('codigoQRenTicketsDesc') }}</p>
                        </div>
                      </div>
                      <div class="action-item">
                        <div class="action-icon">
                          <i class="fas fa-check-circle"></i>
                        </div>
                        <div class="action-content">
                          <h5>{{ $t('comprobacionInstantanea') }}</h5>
                          <p>{{ $t('comprobacionInstantaneaDesc') }}</p>
                        </div>
                      </div>
                      <div class="action-item">
                        <div class="action-icon">
                          <i class="fas fa-lock"></i>
                        </div>
                        <div class="action-content">
                          <h5>{{ $t('seguridadGarantizada') }}</h5>
                          <p>{{ $t('seguridadGarantizadaDesc') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Caso de exento (Paso 5) -->
              <div v-if="step === 5" class="step-4-container">

                <div class="success-header">
                  <div class="success-icon-container">
                    <div class="icon-circle icon-success success-icon-bg">
                      <i class="fas fa-minus-circle" style="font-size: 40px;"></i>
                    </div>
                    <div class="success-checkmark">
                      <i class="fas fa-check"></i>
                    </div>
                  </div>
                  <div class="success-title icon-title">
                    <h3>{{ $t('negocioExentoVerifactu') }}</h3>
                    <p class="subtitle">{{ negocioNombre }}</p>
                  </div>
                </div>

                <div class="success-content">
                  <div class="success-info">
                    <div class="info-row">
                      <div class="info-item-success">
                        <i class="fas fa-check-circle text-success"></i>
                        <span>{{ $t('negocioRegistradoComoExento') }}</span>
                      </div>
                      <div class="info-item-success">
                        <i class="fas fa-shield-alt text-success"></i>
                        <span>{{ $t('noRequiereVerifactu') }}</span>
                      </div>
                      <div class="info-item-success">
                        <i class="fas fa-file-invoice text-success"></i>
                        <span>{{ $t('facturacionNormalContinua') }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="sii-exemption-notice compact">
                    <div class="notice-icon">
                      <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="notice-content">
                      <h4>{{ $t('siHayAlgunError') }}</h4>
                      <p>{{ $t('siHayAlgunErrorDesc') }}</p>
                    </div>
                  </div>

                </div>
              </div>

              <!-- Paso 6: Certificado expirado o proximo a expirar (ambos casos) -->
              <div v-if="step === 6" class="step-4-container">

                <div class="success-header">
                  <div class="success-icon-container">
                    <div
                      class="icon-circle icon-success success-icon-bg"
                      :style="certificateExpired
                        ? 'background: linear-gradient(135deg, #dc3545, #c82333); box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);'
                        : 'background: linear-gradient(135deg, #ffc107, #ff9800); box-shadow: 0 8px 25px rgba(255, 193, 7, 0.3);'"
                    >
                      <i class="fas fa-certificate"></i>
                    </div>
                    <div
                      class="success-checkmark"
                      :style="certificateExpired
                        ? 'background: #white; border-color: #dc3545; box-shadow: 0 2px 8px rgba(220, 53, 69, 0.15);'
                        : 'background: #white; border-color: #ffc107; box-shadow: 0 2px 8px rgba(255, 193, 7, 0.15);'"
                    >
                      <i :class="certificateExpired ? 'fas fa-exclamation-triangle' : 'fas fa-exclamation-triangle'"
                          :style="certificateExpired ? 'color: #dc3545;' : 'color: #ff9800;'"  ></i>
                    </div>
                  </div>
                  <div class="success-title icon-title">
                    <h3 :style="certificateExpired ? 'color: #dc3545;' : 'color: #ff9800;'">
                      {{ certificateExpired ? $t('certificadoExpirado') : $t('certificadoProximoExpirar') }}
                    </h3>
                    <p class="subtitle">{{ negocioNombre }}</p>
                  </div>
                </div>

                <!-- Información de validez del certificado -->
                <div v-if="verifactuFechaError" class="alert alert-danger certificate-validity-info"
                  style="border: 2px solid #dc3545;">
                  <i class="fas fa-exclamation-triangle mr-2"></i>
                  <span>{{ $t('noSeHaPodidoVerificarFecha') }}</span>
                </div>
                <div
                  v-else-if="certificateValidTo"
                  class="alert certificate-validity-info"
                  :class="certificateExpired ? 'alert-danger' : 'alert-warning'"
                  :style="certificateExpired ? 'border: 2px solid #dc3545;' : 'border: 2px solid #ffc107;'"
                >
                  <i class="fas fa-calendar-times mr-2"></i>
                  <span>{{ certificateExpired ? $t('certificadoExpiroEl') : $t('certificadoExpiraEl') }}: <strong>{{ formattedCertificateValidTo }}</strong></span>
                </div>

                <div class="certificate-content">
                  <div class="info-section">
                    <div class="info-item-success"
                      :style="certificateExpired
                        ? 'border-left-color: #dc3545; box-shadow: 0 2px 8px rgba(220, 53, 69, 0.1);'
                        : 'border-left-color: #ffc107; box-shadow: 0 2px 8px rgba(255, 193, 7, 0.1);'"
                    >
                      <i :class="certificateExpired ? 'fas fa-times-circle text-danger' : 'fas fa-exclamation-triangle text-warning'"></i>
                      <span>{{ certificateExpired ? $t('certificadoYaNoValido') : $t('certificadoProntoVencera') }}</span>
                    </div>
                    <div class="info-item-success"
                      :style="certificateExpired
                        ? 'border-left-color: #dc3545; box-shadow: 0 2px 8px rgba(220, 53, 69, 0.1);'
                        : 'border-left-color: #ffc107; box-shadow: 0 2px 8px rgba(255, 193, 7, 0.1);'"
                    >
                      <i :class="certificateExpired ? 'fas fa-ban text-danger' : 'fas fa-clock text-warning'"></i>
                      <span>{{ certificateExpired ? $t('sinCertificadoNoEsPosibleVerificar') : $t('EsperarAExpiracionPuedeProvocarErrores') }}</span>
                    </div>
                    <div class="info-item-success"
                      :style="certificateExpired
                        ? 'border-left-color: #dc3545; box-shadow: 0 2px 8px rgba(220, 53, 69, 0.1);'
                        : 'border-left-color: #ffc107; box-shadow: 0 2px 8px rgba(255, 193, 7, 0.1);'"
                    >
                      <i :class="certificateExpired ? 'fas fa-tools text-danger' : 'fas fa-tools text-warning'"></i>
                      <span v-html="$t('formatosSoportados')"></span>
                    </div>

                  </div>

                  <div class="mobile-separator" id="desktop-separator-step6"></div>

                  <div class="action-column" id="certificate-upload-desktop-step6">

                    <div class="action-section">

                      <div v-if="!showUploader">
                        <p class="action-text">{{ $t('renovarCertificado') }}</p>
                        <small class="action-subtitle">{{ $t('hazClickAbrirSelector') }}</small>
                        <button class="btn-certificate" @click="solicitarVerifactu">
                          <i class="fas fa-certificate"></i>
                          <span>{{ $t('tengoUnCertificado') }}</span>
                          <i class="fas fa-arrow-right"></i>
                        </button>
                      </div>

                      <div v-else class="uploader-section">

                        <div class="upload-area" @click="triggerFileInputStep6">

                          <input ref="fileInputStep6" type="file" @change="handleFileUpload" accept=".pfx,.p12"
                            style="display: none;" />

                          <div v-if="!selectedFile" class="upload-prompt">
                            <i class="fas fa-cloud-upload-alt"></i>
                            <p>{{ $t('hazClickSeleccionarCertificado') }}</p>
                            <small>{{ $t('formatosMaximo') }}</small>
                          </div>

                          <div v-else class="file-selected">

                            <i class="fas fa-cloud-upload-alt"></i>
                            <p>{{ $t('hazClickSeleccionarCertificado') }}</p>

                            <div class="file-info-selected">
                              <p class="file-details">{{ selectedFile.name.toUpperCase() }} - {{
                                formatFileSize(selectedFile.size) }}</p>
                            </div>

                            <button class="btn-upload" @click.stop="enviarCertificado">
                              <i class="fas fa-upload" style="color: #fff;"></i> {{ $t('subirCertificado') }}
                            </button>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de contraseña del certificado -->
      <div v-if="showPasswordModal" class="password-modal-overlay" @click="closePasswordModal">
        <div class="password-modal" @click.stop>
          <div class="modal-header">
            <div class="modal-icon">
              <i class="fas fa-key"></i>
            </div>
            <h3>{{ $t('contrasenaCertificado') }}</h3>
            <button class="modal-close" @click="closePasswordModal">
              <i class="fas fa-times"></i>
            </button>
          </div>

          <div class="modal-body">
            <p class="modal-description">
              {{ $t('introduceContrasenaDesc') }}
            </p>

            <div class="password-input-group" :class="{ 'error': passwordError }">
              <label for="certificate-password">{{ $t('contrasena') }}</label>
              <input id="certificate-password" type="password" v-model="certificatePassword"
                @keyup.enter="confirmPassword" :class="{ 'error': passwordError }"
                :placeholder="$t('introduceContrasenaPlaceholder')" autocomplete="new-password" />
              <div v-if="passwordError" class="error-message">
                <i class="fas fa-exclamation-triangle"></i>
                {{ $t('contrasenaRequerida') }}
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn-confirm" @click="confirmPassword"
              :disabled="!certificatePassword.trim() || uploadLoading">
              <i :class="uploadLoading ? 'fas fa-spinner fa-spin' : 'fas fa-check'"></i>
              <span>{{ uploadLoading ? $t('procesando') : $t('continuar') }}</span>
            </button>
            <button class="btn-cancel" @click="closePasswordModal">
              <i class="fas fa-times"></i>
              {{ $t('cancelar') }}
            </button>
          </div>
        </div>
      </div>

      <!-- Modal de confirmación SII (exento) -->
      <div v-if="showSIIConfirmModal" class="password-modal-overlay" @click="cancelarExencionSII">
        <div class="password-modal sii-modal" @click.stop>
          <div class="modal-header">
            <div class="modal-icon modal-icon-warning">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <h3>{{ $t('confirmacionExencionSII') }}</h3>
            <button class="modal-close" @click="cancelarExencionSII">
              <i class="fas fa-times"></i>
            </button>
          </div>

          <div class="modal-body">
            <p class="modal-description">
              <strong>{{ $t('antesDeConfirmar') }}</strong>
            </p>

            <ul class="sii-checklist">
              <li><i class="fas fa-check-circle"></i> {{ $t('miNegocioEstaAdscritoSistemaInmediato') }}</li>
              <li><i class="fas fa-check-circle"></i> {{ $t('tengoDocumentacionQueLoAcredita') }}</li>
              <li><i class="fas fa-check-circle"></i> {{ $t('entiendoQueNoDebereUsarVerifactu') }}</li>
            </ul>

            <p class="text-muted-small">
              <i class="fas fa-info-circle"></i> {{ $t('siNoEstasSegurotConsultaAsesor') }}
            </p>
          </div>

          <div class="modal-footer">
            <button class="btn-cancel" @click="cancelarExencionSII">
              <i class="fas fa-times"></i>
              {{ $t('cancelar') }}
            </button>
            <button class="btn-confirm btn-confirm-warning" @click="confirmarExencionSII" :disabled="siiConfirmTimer > 0 || uploadLoading">
              <i :class="uploadLoading ? 'fas fa-spinner fa-spin' : 'fas fa-check'"></i>
              <span v-if="uploadLoading">{{ $t('procesando') }}</span>
              <span v-else>{{ $t('confirmarExencion') }}<span v-if="siiConfirmTimer > 0"> ({{ siiConfirmTimer }})</span></span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de aplazamiento Verifactu -->
    <info-modal
      :visible="mostrarONoModalAplazamiento"
      type="info"
      image="aplazamiento-verifactu.png"
      header-text="verifactuAplazadoTitulo"
      body-text="verifactuAplazadoMensaje"
      button-text-key="entendido"
      action="close"
      :close-on-backdrop="false"
      @close="cerrarModalAplazamiento"
    />
  </div>


</template>

<script>

import Swal from "sweetalert2";
import InfoModal from '@/components/Modal/InfoModal.vue';
import {
  Loading,
  Option,
  Select,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Button
} from 'element-ui';
import DashboardLayout from '../Layout/DashboardLayout.vue';
import { cos } from 'mathjs';
export default {
  name: 'VerifactuDashboard',
  components: {
    DashboardLayout,
    InfoModal,
    [Option.name]: Option,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,

  },

  mounted() {
    // No mostraremos otra vez lo de verifacu hasta junio de 2026
    const fechaNuevaRondaVerifactu = new Date('2026-06-01T00:00:00');
    const ahora = new Date();

    // if (ahora < fechaNuevaRondaVerifactu) {
      this.mostrarONoModalAplazamiento = true;
    //   return;
    // }

    this.loading = Loading.service({ text: "Cargando..." });

    this.getBusiness().then(() => {
      return this.getPerfil();
    }).then(() => {
      // if (this.idBusiness) {
      //   return this.getStatusVerifactu(this.idBusiness);
      // }
    }).finally(() => {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    });
  },
  data() {
    return {
      step: 1,
      selectedFile: null,
      showUploader: false,
      negocioId: null,
      negocioNombre: null,
      usuarioNombre: '',
      idBusiness: null,
      idUser: null,
      loading: null,
      uploadLoading: null,
      showAlert: false,
      showPasswordModal: false,
      certificatePassword: '',
      passwordError: false,
      verifactuDateSelected: false,
      selectedStartOption: null,
      verifactuStartOption: null, // 1 = Enero 2026, 2 = Julio 2026, null = no seleccionado
      showSIIConfirmModal: false,
      siiConfirmTimer: 0,
      siiConfirmInterval: null,
      certificateValidTo: null,
      verifactuFechaError: false,
      certificateExpired: false,
      certificateAboutToExpire: false,
      mostrarONoModalAplazamiento: false,
    };
  },
  methods: {
    getIdUser() {
      const token = this.$store.state.xjwt;
      if (!token) {
        console.error("No se encontró el token JWT.");
        return null;
      }

      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        const decodedJWT = JSON.parse(jsonPayload);
        return decodedJWT.idUser || null;
      } catch (error) {
        console.error("Error al decodificar el token JWT:", error);
        return null;
      }
    },
    async solicitarVerifactu() {

      if (!this.idBusiness) {
        this.showAlert = true;
        setTimeout(() => {
          this.showAlert = false;
        }, 3500);
        return;
      }

      this.showUploader = true;

      this.selectedFile = null;

      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = '';
      }
    },

    getPdfUrl(filename) {
      const baseUrl = 'https://numier.com/recursos/verifactu/';
      return baseUrl + encodeURIComponent(filename);
    },

    getBusiness() {
      return new Promise((resolve, reject) => {
        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        this.axios
          .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
          .then((response) => {
            this.$store.commit('loadListBusiness', response.data.result.map((business) => ({
              id: business.id,
              establishmentName: business.establishmentName,
              statusVerifactu: business.statusVerifactu || 'ok',
            })));
            resolve();
          })
          .catch((error) => {
            console.error("Error al obtener negocios:", error);
            reject(error);
          });
      });
    },

    getPerfil() {
      return new Promise((resolve, reject) => {
        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        this.axios
          .get(this.$store.state.xapiUrl + "general/getPerfilBasico", config)
          .then((response) => {
            if (response.data.response && response.data.result.perfil) {
              this.usuarioNombre = `${response.data.result.perfil.firstName} ${response.data.result.perfil.surName}`;
              this.idUser = response.data.result.perfil.id;
              resolve();
            } else {
              console.error("No se encontró el perfil en la respuesta.");
              reject(new Error("Perfil no encontrado"));
            }
          })
          .catch((error) => {
            console.error("Error al obtener el perfil:", error);
            reject(error);
          });
      });
    },

    cambioNegocio() {

      const negocioSeleccionado = this.businesses.find(
        (business) => business.id === this.idBusiness
      );

      if (negocioSeleccionado) {
        this.negocioNombre = negocioSeleccionado.establishmentName;

        this.selectedFile = null;
        this.showUploader = false;
        this.verifactuDateSelected = false;
        this.selectedStartOption = null;
        this.verifactuStartOption = null;
        this.verifactuFechaError = false;
        this.certificateExpired = false;
        this.certificateAboutToExpire = false;

        this.step = null;

        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.value = '';
        }

        this.loading = Loading.service({
          text: "Cargando estado de Verifactu...",
          lock: true,
          background: 'rgba(255, 255, 255, 0.9)'
        });

        this.getStatusVerifactu(this.idBusiness).finally(() => {
          if (this.loading) {
            this.loading.close();
            this.loading = null;
          }
        });

      } else {
        console.error("No se encontró el negocio seleccionado.");
        this.step = 1;
        this.selectedStartOption = null;
        this.verifactuStartOption = null;
        this.verifactuDateSelected = false;
        this.verifactuFechaError = false;
        this.certificateExpired = false;
        this.certificateAboutToExpire = false;
      }
    },

    async getStatusVerifactu(idBusiness) {
      try {

        const response = await this.axios.get(
          `${this.$store.state.xapiUrl}verifactu/getStatusVerifactu/${idBusiness}`,
          {
            headers: { Authorization: "Bearer " + this.$store.getters.jwt }
          }
        );

        if (response.data && response.data.data) {
          const status = response.data.data.status;
          const exent = response.data.data.exent;
          const validTo = response.data.data.validTo_time;
          const expired = response.data.data.expired || false;
          const aboutToExpire = response.data.data.aboutToExpire || false;

          if (validTo) {
            this.certificateValidTo = validTo;
          }

          this.certificateExpired = expired;
          this.certificateAboutToExpire = aboutToExpire;

          // Traduccion de status a statusVerifactu para la lista global
          let statusVerifactu = 'sin_configurar';
          if (exent == 1) {
            statusVerifactu = 'exento';
          } else if (status == 2) {
            if (expired) {
              statusVerifactu = 'expirado';
            } else if (aboutToExpire) {
              statusVerifactu = 'expira_pronto';
            } else {
              statusVerifactu = 'configurado';
            }
          } else {
            statusVerifactu = 'sin_configurar';
          }
          this.$store.commit('updateBusinessStatus', {
            id: idBusiness,
            statusVerifactu
          });

          await this.$nextTick();

          if (exent == 1) {
            this.step = 5;
            this.verifactuDateSelected = true;
            this.verifactuFechaError = false;
            await this.$nextTick();
          } else if (status == 2) {
            if (expired || aboutToExpire) {
              this.step = 6;
              this.verifactuDateSelected = true;
              this.verifactuFechaError = false;
            } else {
              this.step = 4;
              this.verifactuDateSelected = true;
              if (!validTo) {
                this.verifactuFechaError = true;
              } else {
                this.verifactuFechaError = false;
              }
            }

            await this.$nextTick();
          } else {
            this.step = 1;
            this.verifactuDateSelected = false;
            this.verifactuFechaError = false;

            await this.$nextTick();
          }

          return status;
        } else {
          this.step = 1;
          this.verifactuDateSelected = false;
          this.verifactuFechaError = false;
          return null;
        }
      } catch (error) {
        this.step = 1;
        this.verifactuDateSelected = false;
        this.verifactuFechaError = false;
        return null;
      }
    },

    async enviarCertificado() {

      if (!this.selectedFile) {
        this.showNotification(this.$t('seleccionaArchivoAntes'), "error");
        return;
      }

      if (!this.idBusiness) {
        this.showNotification(this.$t('errorNegocioNoValido'), "error");
        console.error("No se ha encontrado el ID del negocio:", this.idBusiness);
        return;
      }


      // DEBUG: Forzar valor incorrecto para probar validaciones
      // this.verifactuStartOption = 'ASDASD';

      if (this.step !== 6) {
        if (!this.verifactuStartOption || (this.verifactuStartOption !== 1 && this.verifactuStartOption !== 2)) {
          // console.error("Error: verifactuStartOption inválido al intentar enviar certificado", {
          //   step: this.step,
          //   verifactuStartOption: this.verifactuStartOption,
          //   selectedStartOption: this.selectedStartOption
          // });

          this.showNotification(this.$t('debeSeleccionarFechaInicioVerifactu'), "error");

          this.resetStepsWhenError();
          return;
        }
      }

      // Mostrar modal para pedir contraseña
      this.showPasswordModal = true;
    },

    resetStepsWhenError() {
      // console.log("=== RESET: Volviendo al paso de selección de fecha ===");

      // Resetear archivos, uploader, pass
      this.selectedFile = null;
      this.showUploader = false;

      this.certificatePassword = '';
      this.passwordError = false;
      this.showPasswordModal = false;

      // Solo resetear fecha si NO estamos en step 6 (renovacion)
      if (this.step !== 6) {
        this.verifactuDateSelected = false;
        this.selectedStartOption = null;
        this.verifactuStartOption = null;
      }

      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = '';
      }

      // Volver al step 1 SOLO si no estamos en renovacion (step 6)
      // En step 6 (renovacion) no necesitamos seleccionar fecha
      if (this.step !== 6) {
        this.step = 1;
        this.showNotification(
          this.$t('porFavorSeleccionaFechaInicioNuevamente'),
          'warning'
        );
      } else {
        // En step 6, solo indicamos que seleccione otro certificado
        this.showNotification(
          this.$t('porFavorSeleccionaCertificadoNuevamente'),
          'warning'
        );
      }
    },

    async procesarCertificado() {

      const idUser = this.getIdUser();

      if (!idUser) {
        this.showNotification(this.$t('noSePudoObtenerIdUsuario'), "error");
        return;
      }

      const formData = new FormData();
      formData.append("certificado", this.selectedFile);
      formData.append("idBusiness", parseInt(this.idBusiness));
      formData.append("idUser", parseInt(idUser));
      formData.append("password", this.certificatePassword);


      // DEBUG: Forzar valor incorrecto para probar validaciones
      // this.verifactuStartOption = 'ASDASD';

      // Solo enviar startOption si NO estamos en el step 6 (renovacion)
      // startOption: 1 = Enero 2026, 2 = Julio 2026
      if (this.step !== 6) {
        const startOptionValue = parseInt(this.verifactuStartOption, 10);

        // Validacion extra antes de enviar
        if (isNaN(startOptionValue) || (startOptionValue !== 1 && startOptionValue !== 2)) {
          console.error("Error crítico: startOption inválido antes de enviar", {
            verifactuStartOption: this.verifactuStartOption,
            startOptionValue: startOptionValue,
            step: this.step
          });

          this.showNotification(this.$t('debeSeleccionarFechaInicioVerifactu'), "error");
          this.resetStepsWhenError();
          return;
        }

        formData.append("startOption", startOptionValue);
      }

      try {
        this.uploadLoading = Loading.service({
          text: this.$t('verificandoCertificado'),
          lock: true,
          background: 'rgba(0, 0, 0, 0.4)',
          color: 'white'
        });

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + this.$store.getters.jwt,
          }
        };

        // console.log("Enviando formulario con los siguientes datos:");
        // console.log("Certificado:", this.selectedFile);
        // console.log("idUser:", idUser);
        // console.log("idBusiness:", this.idBusiness);
        // console.log("startOption:", this.verifactuStartOption);

        // Selecciona el endpoint segun el paso
        const endpoint = this.step === 6
          ? this.$store.state.xapiUrl + "verifactu/renovarCertificado"
          : this.$store.state.xapiUrl + "verifactu/guardarCertificadoYEstablecerEstado";

        const response = await this.axios.post(
          endpoint,
          formData,
          config
        );

        if (response && response.status === 200) {

          if (this.uploadLoading) {
            this.uploadLoading.close();
            this.uploadLoading = null;
          }

          this.showPasswordModal = false;

          const successMessage = response.data.message || this.$t('certificadoEnviadoCorrectamente');
          this.showNotification(successMessage, "success");

          // this.step = 4;
          this.showUploader = false;

          await this.getStatusVerifactu(this.idBusiness);

          // Actualizar el estado del negocio en la lista global del store
          // De esta manera tambien deberia actualizarse tras una subida de certificado
          let newStatus = 'configurado';
          if (this.certificateExpired) {
            newStatus = 'expirado';
          } else if (this.certificateAboutToExpire) {
            newStatus = 'expira_pronto';
          }

          this.$store.commit('updateBusinessStatus', {
            id: this.idBusiness,
            statusVerifactu: newStatus
          });

        } else {
          if (this.uploadLoading) {
            this.uploadLoading.close();
            this.uploadLoading = null;
          }

          const errorMsg = response.data.message || this.$t('respuestaInesperadaServidor');
          this.showNotification(errorMsg, "error");
        }
      } catch (error) {
        if (this.uploadLoading) {
          this.uploadLoading.close();
          this.uploadLoading = null;
        }

        console.error("Error en procesarCertificado:", error);
        let errorMsg = "Error al enviar el certificado";
        let shouldResetSteps = false;

        if (error.response && error.response.data) {
          const statusCode = error.response.status;
          const errorCode = error.response.data.code;

          // En caso de error de fecha de inicio
          if (errorCode === 'ERR_FECHA_INICIO') {
            console.error("Error de fecha de inicio detectado desde la API");
            errorMsg = error.response.data.message || 'Error al verificar fecha de inicio. Por favor, selecciona nuevamente la fecha.';
            shouldResetSteps = true;
          } else if (statusCode === 403) {
            errorMsg = this.$t('verifactuError449') || error.response.data.message;
          } else {
            errorMsg = this.$t('verifactuError552') || error.response.data.message;
            if (error.response.data && error.response.data.message) {
              errorMsg = error.response.data.message || errorMsg;
            }
          }

          // console.error("Detalles del error:", error.response.data);
        } else if (error.request) {
          errorMsg = this.$t('noSeRecibioRespuestaServidor');
          // console.error("Request:", error.request);
        } else {
          errorMsg = `${this.$t('errorDeConfiguracion')} ${error.message}`;
        }

        this.showNotification(errorMsg, "error");

        // reset por mala fecha
        if (shouldResetSteps) {
          this.resetStepsWhenError();
        }
      } finally {
        if (!this.showPasswordModal) {
          this.certificatePassword = '';
          this.passwordError = false;
        }
      }
    },

    closePasswordModal() {
      if (this.uploadLoading) return;

      this.showPasswordModal = false;
      this.certificatePassword = '';
      this.passwordError = false;
    },

    confirmPassword() {
      if (this.uploadLoading) return;

      if (!this.certificatePassword.trim()) {
        this.passwordError = true;
        return;
      }

      this.passwordError = false;
      // this.showPasswordModal = false;
      this.procesarCertificado();
    },

    seleccionarFechaInicio(opcion) {

      if (opcion === 'exento') {
        // Mostrar modal de confirmación
        this.showSIIConfirmModal = true;
        this.selectedStartOption = 'exento';
        this.siiConfirmTimer = 4;
        if (this.siiConfirmInterval) clearInterval(this.siiConfirmInterval);
        this.siiConfirmInterval = setInterval(() => {
          if (this.siiConfirmTimer > 0) {
            this.siiConfirmTimer--;
          } else {
            clearInterval(this.siiConfirmInterval);
            this.siiConfirmInterval = null;
          }
        }, 1000);
      } else {

        // Guardar opcion seleccionada como 1 (enero) o 2 (julio)
        this.selectedStartOption = opcion;

        if (opcion === 'enero') {
          this.verifactuStartOption = 1; // 1 de Enero de 2026
        } else if (opcion === 'julio') {
          this.verifactuStartOption = 2; // 1 de Julio de 2026
        }

        this.verifactuDateSelected = true;

        this.$nextTick(() => {
          const certificateSection = document.querySelector('.certificate-upload-mobile');
          if (certificateSection) {
            certificateSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    },

    async confirmarExencionSII() {
      if (this.siiConfirmTimer > 0 || this.uploadLoading) return;
      try {
        this.uploadLoading = Loading.service({
          lock: true,
          text: this.$t('procesando'),
          background: 'rgba(0, 0, 0, 0.7)'
        });

        const config = {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt }
        };

        const response = await this.axios.post(
          `${this.$store.state.xapiUrl}verifactu/negocioExentoSII`,
          {
            idBusiness: this.idBusiness,
            idUser: this.getIdUser()
          },
          config
        );

        if (response.status === 200) {
          if (this.uploadLoading) {
            this.uploadLoading.close();
            this.uploadLoading = null;
          }

          this.step = 5;
          this.selectedStartOption = 'exento';
          this.verifactuDateSelected = true;
          this.showNotification(
            this.$t('negocioMarcadoComoExento'),
            'success'
          );

          // Actualizar en el store (igual que tras confirmar la subida)
          this.$store.commit('updateBusinessStatus', {
            id: this.idBusiness,
            statusVerifactu: 'exento'
          });

          await this.getStatusVerifactu(this.idBusiness);
        }
      } catch (error) {
        console.error('Error al marcar exención SII:', error);
        this.showNotification(
          this.$t('errorAlMarcarExencion'),
          'error'
        );
        // Resetear en caso de error
        this.selectedStartOption = null;
        this.verifactuStartOption = null;
        this.verifactuDateSelected = false;
        this.step = 1;
      } finally {
        if (this.uploadLoading) {
          this.uploadLoading.close();
          this.uploadLoading = null;
        }
        this.showSIIConfirmModal = false;
        if (this.siiConfirmInterval) {
          clearInterval(this.siiConfirmInterval);
          this.siiConfirmInterval = null;
        }
        this.siiConfirmTimer = 0;
      }
    },

    cancelarExencionSII() {
      this.showSIIConfirmModal = false;
      this.selectedStartOption = null;
      this.verifactuStartOption = null;
      if (this.siiConfirmInterval) {
        clearInterval(this.siiConfirmInterval);
        this.siiConfirmInterval = null;
      }
      this.siiConfirmTimer = 0;
    },

    cambiarFechaSeleccionada() {
      this.verifactuDateSelected = false;
      this.selectedStartOption = null;
      this.verifactuStartOption = null;
      this.showUploader = false;
      this.selectedFile = null;
      this.verifactuFechaError = false;
      this.certificateExpired = false;
      this.certificateAboutToExpire = false;
    },

    showNotification(message, type = 'success') {
      const options = {
        title: type === 'error' ? this.$t("error") : this.$t("exito"),
        text: message,
        icon: type,
        confirmButtonText: "OK",
        confirmButtonColor: type === 'error' ? "#F44336" : "#4CAF50",
        buttonsStyling: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      };

      Swal.fire(options);
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    triggerFileInputStep6() {
      this.$refs.fileInputStep6.click();
    },

    handleFileUpload(event) {
      const file = event.target.files[0];

      if (!file) {
        this.showNotification(this.$t('noSeSeleccionoArchivo'), "error");
        return;
      }

      // Solo .pfx y .p12
      const validExtensions = ['pfx', 'p12'];
      const fileExtension = (file.name.split('.').pop() || '').toLowerCase();

      if (!validExtensions.includes(fileExtension)) {
        this.showNotification(this.$t('formatoArchivoNoValido'), "error");

        // Limpiar el input y la variable
        event.target.value = '';
        this.selectedFile = null;
        return;
      }

      const maxSize = 60 * 1024;
      if (file.size > maxSize) {
        this.showNotification(this.$t('archivoDemasiadoGrande'), "error");

        event.target.value = '';
        this.selectedFile = null;
        return;
      }

      this.selectedFile = file;
      // console.log("Archivo seleccionado:", file.name);
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    cerrarModalAplazamiento() {
      this.mostrarONoModalAplazamiento = false;
      this.$router.push({ name: 'informes' });
    },

  },

  computed: {
    formattedCertificateValidTo() {
      if (!this.certificateValidTo) return this.$t('noDisponible');

      const date = new Date(this.certificateValidTo);

      // Formatear a dd/mm/yyyy
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    businesses() {
      return this.$store.state.xlistBusiness;
    },
    selectedBusiness() {
      if (!this.idBusiness || !this.businesses.length) return null;
      return this.businesses.find(business => business.id === this.idBusiness);
    }
  },

  watch: {
    idBusiness(newId, oldId) {
      if (newId !== oldId) {
        this.cambioNegocio();
      }
    },
  }
}

</script>

<style scoped>

.declaraciones-dropdown {
  display: inline-block;
  margin-top: .8rem;
}

.declaraciones-dropdown .el-button {
  font-weight: 500;
  padding: 12px 20px;
}

.declaraciones-dropdown .el-dropdown-menu__item {
  padding: 10px 20px;
}

.declaraciones-dropdown .el-dropdown-menu__item strong {
  display: flex;
  align-items: center;
  gap: 8px;
}

.business-select-wrapper {
  position: relative;
  min-width: 350px;
  width: 100%;
}

.business-status-icon {
  position: absolute;
  right: 32px;
  top: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1;
  display: flex;
  align-items: center;
}

.container {
  --transition: 350ms;
  --folder-W: 120px;
  --folder-H: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 10px;
  background: linear-gradient(135deg, #6dd5ed, #2193b0);
  border-radius: 15px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
  height: calc(var(--folder-H) * 1.7);
  position: relative;
  margin: 20px auto;
  width: 100%;
  max-width: 300px;
}

.card {
  /* border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
  margin-bottom: 16px;
  padding: 20px 20px 10px 20px;
}

.select-default {
  min-width: 350px;
}

.card-header {
  padding: 10px;
  max-height: 70px;
  font-size: 18px;
  font-weight: bold;
}

.card-header h4 {
  margin: 0;
  font-size: 24px;
  color: #fff;
}

.card-body {
  padding: 20px;
}

.text-muted {
  font-size: 16px;
}

.btn-primary {
  font-size: 14px;
  padding: 10px 20px;
}

.step-container {
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  background-color: #f8f9fa;
}

.step-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #2c3e50;
}

.step-1-container {
  padding: 20px 20px;
  width: 100%;
}

.certificate-info-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e9ecef;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 100%;
  max-width: 100%;
  position: relative;
  overflow: hidden;
}

.certificate-info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #007bff, #28a745);
}

.certificate-header {
  display: flex;
  align-items: center;
  margin: 20px 0;
  gap: 20px;
}

.icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: relative;
}

.icon-circle i {
  color: white;
  font-size: 36px;
}

.icon-title h3 {
  margin: 0 0 5px 0;
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
}

.icon-title .subtitle {
  margin: 0;
  font-size: 18px;
  color: #6c757d;
  font-weight: 500;
}

.certificate-title h3 {
  margin: 0 0 5px 0;
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
}

.certificate-title .subtitle {
  margin: 0;
  font-size: 18px;
  color: #6c757d;
  font-weight: 500;
}

.certificate-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 40px;
  align-items: start;
}

.info-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  border-left: 4px solid #007bff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.info-item:hover {
  transform: translateX(5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.info-item i {
  font-size: 20px;
  margin-top: 2px;
  flex-shrink: 0;
}

.info-item span {
  font-size: 16px;
  line-height: 1.6;
  color: #495057;
}

.info-item code {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 14px;
  color: #e83e8c;
}

.help-divider {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
  position: relative;
}

.help-divider span {
  background: #f8f9fa;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #6c757d;
  border: 1px solid #e9ecef;
}

.renewal-divider {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 25px;
  position: relative;
}

.renewal-divider span {
  background: #f8f9fa;
  padding: 10px 24px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 600;
  color: #495057;
  border: 2px solid #dee2e6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.certificate-renewal-section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 2px solid #e9ecef;
}

.help-item {
  border-left-color: #17a2b8 !important;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
}

.help-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.help-meta {
  display: flex;
  align-items: start;
  gap: 12px;
}

.help-meta i {
  font-size: 18px;
  color: #17a2b8;
  flex-shrink: 0;
}

.help-meta .meta-text span {
  font-size: 15px;
  color: #495057;
}

.help-meta .meta-text {
  flex: 1 1 auto;
  text-align: left;
}

.meta-action {
  margin-top: 14px;
  display: flex;
  justify-content: center;
}

.meta-action .certificate-link {
  display: inline-flex;
}

.info-item.help-item {
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px;
  padding: 18px 20px;
}

.info-item.help-item .help-meta {
  width: 100%;
  justify-content: center;
}

.info-item.help-item .meta-action {
  width: 100%;
  margin-top: 12px;
}

.certificate-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #17a2b8, #138496);
  color: white;
  text-decoration: none;
  padding: 12px 18px;
  border-radius: 25px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 3px 10px rgba(23, 162, 184, 0.3);
  align-self: center;
}

.certificate-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(23, 162, 184, 0.4);
  background: linear-gradient(135deg, #138496, #117a8b);
  color: white;
  text-decoration: none;
}

.certificate-link i:first-child {
  font-size: 16px;
}

.certificate-link i:last-child {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.certificate-link:hover i:last-child {
  transform: translateX(2px);
}

.action-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 15px;
  border: 1px solid #dee2e6;
  align-self: center;
  text-align: center;
}

.action-column {
  /* margin-bottom: 50px; */
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: center;
}

.action-subtitle {
  display: block;
  font-size: 13px;
  color: #6c757d;
  margin: 6px 0 20px 0;
}

.action-subtitle a {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}

.action-subtitle a:hover {
  color: #0056b3;
}

.mobile-separator {
  display: none;
}

#certificate-upload-mobile {
  display: none;
}

#certificate-upload-desktop {
  display: flex;
}

#desktop-separator {
  display: none;
}

#desktop-separator-step6 {
  display: none;
}

/* Separadores de la version movil */
.mobile-separator-top,
.mobile-separator-bottom {
  display: none;
}


.action-section>div {
  width: 100%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.action-text {
  font-size: 18px;
  color: #495057;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0;
}

.btn-certificate {
  display: inline-flex;
  align-items: center;
  gap: 15px;
  background: linear-gradient(135deg, #17a2b8, #138496);
  color: white;
  border: none;
  padding: 18px 35px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(19, 132, 150, 0.25);
  text-decoration: none;
  min-width: 220px;
  justify-content: center;
}

.btn-certificate:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(19, 132, 150, 0.35);
  background: linear-gradient(135deg, #138496, #117a8b);
  color: white;
}

.btn-certificate:active {
  transform: translateY(0);
}

.btn-certificate i:first-child {
  font-size: 18px;
}

.btn-certificate i:last-child {
  font-size: 14px;
  transition: transform 0.3s ease;
}

.btn-certificate:hover i:last-child {
  transform: translateX(3px);
}

.uploader-section {
  width: 100%;
}

.upload-area {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 2px dashed #007bff;
  border-radius: 12px;
  padding: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-area:hover {
  border-color: #0056b3;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.2);
}

.upload-prompt i {
  font-size: 48px;
  color: #138496;
  margin-bottom: 15px;
  display: block;
}

.upload-prompt p {
  font-size: 18px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.upload-prompt small {
  font-size: 14px;
  color: #6c757d;
}

.file-selected {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.file-info-selected {
  background: linear-gradient(135deg, #e8f5e8 0%, #f0f8f0 100%);
  border: 1px solid #28a745;
  border-radius: 12px;
  padding: 12px 16px;
  text-align: center;
  margin-bottom: 4px;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.1);
}

.file-details {
  font-size: 14px !important;
  font-weight: 600;
  color: #138496;
  margin: 0;
  word-break: break-all;
  text-align: center;
}

.file-selected i {
  font-size: 48px;
  color: #138496;
}

.file-selected p {
  font-size: 18px;
  font-weight: 600;
  color: #495057;
  margin: 0;
}

.btn-upload {
  background: linear-gradient(135deg, #17a2b8, #138496);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(19, 132, 150, 0.2);
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-upload:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(19, 132, 150, 0.3);
  background: linear-gradient(135deg, #138496, #117a8b);
}

.btn-upload i {
  font-size: 16px;
}

.alert-danger {
  padding: 15px;
  border-radius: 12px;
  background-color: #f8d7da;
  color: #721c24;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.alert-info {
  padding: 15px;
  border-radius: 12px;
  background-color: #d1ecf1;
  color: #0c5460;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.alert-info i {
  font-size: 20px;
}

.alert-warning {
  padding: 15px;
  border-radius: 12px;
  background-color: #fff3cd;
  color: #856404;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.alert-warning i {
  font-size: 20px;
}

.certificate-validity-info {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 16px;
}

.certificate-validity-info strong {
  font-weight: 600;
}

.alert-success p {
  color: #dbe9df;
  font-size: 16px;
  display: block;
}

.alert-success i {
  font-size: 20px;
}

.notification {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 15px;
  border-radius: 5px;
  color: white;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
}

.notification-success {
  background-color: #4CAF50;
}

.notification-error {
  background-color: #F44336;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.swal-custom-popup {
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.swal-custom-button {
  background-color: #4CAF50 !important;
  color: white !important;
  font-weight: bold;
  border-radius: 5px;
}

.verifactu-presentation {
  text-align: center;
  padding: 20px 20px;
}

.presentation-header {
  margin-bottom: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.presentation-title {
  color: #2c3e50;
  font-size: 28px;
  font-weight: bold;
  margin: 14px 0 0 0;
  line-height: 1;
}

.verifactu-logo {
  max-width: 340px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.presentation-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
}

.presentation-description {
  font-size: 16px;
  line-height: 1.6;
  color: #555;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 12px;
  border-left: 4px solid #007bff;
}

.benefits-title {
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
  background-clip: text;
  color: transparent;
  margin-bottom: 35px;
  position: relative;
  padding-bottom: 15px;
}

.benefits-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #3498db, #2c3e50);
  border-radius: 2px;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.benefit-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.benefit-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #007bff;
}

.benefit-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #007bff, #28a745);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.benefit-card:hover::before {
  opacity: 1;
}

.benefit-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  border-radius: 50%;
  margin-bottom: 15px;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.benefit-icon i {
  color: white;
  font-size: 24px;
}

.benefit-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 8px 0;
}

.benefit-content p {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.4;
  margin: 0 0 8px 0;
}

.benefit-detail {
  display: block;
  font-size: 12px;
  color: #8e9ba7;
  font-style: italic;
  line-height: 1.3;
  margin-bottom: 12px;
}

.benefit-stat {
  display: inline-block;
  background: linear-gradient(45deg, #28a745, #20c997);
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.instruction-section .alert {
  padding: 15px 18px;
  font-size: 15px;
  width: 100%;
  border-radius: 12px;
  background: linear-gradient(90deg, #d1ecf1 80%, #b2f0ff 100%);
  border: 2px solid #17a2b8;
  color: #0c5460;
  box-shadow: 0 6px 18px rgba(23, 162, 184, 0.15), 0 1.5px 4px rgba(0, 0, 0, 0.07);
  /* font-weight: 600; */
  transition: box-shadow 0.2s;
}

.instruction-section .alert i {
  font-size: 24px;
}

.sii-exemption-notice {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  border: 2px solid #ffc107;
  border-radius: 12px;
  padding: 14px 22px;
  display: flex;
  gap: 18px;
  align-items: flex-start;
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.15);
}

.sii-exemption-notice.compact {
  margin-bottom: 25px;
  padding: 16px 20px;
}

.sii-exemption-notice .notice-icon {
  flex-shrink: 0;
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #ffc107, #ff9800);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 3px 10px rgba(255, 152, 0, 0.3);
}

.sii-exemption-notice .notice-icon i {
  color: white;
  font-size: 22px;
}

.sii-exemption-notice .notice-content h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 700;
  color: #856404;
  line-height: 1.2;
}

.sii-exemption-notice .notice-content p {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  color: #856404;
}

.sii-exemption-notice .notice-link {
  color: #d68910;
  font-weight: 600;
  text-decoration: underline;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s ease;
}

.sii-exemption-notice .notice-link:hover {
  color: #b87503;
  text-decoration: none;
}

.sii-exemption-notice .notice-link i {
  font-size: 12px;
}

.step-4-container {
  padding: 20px 20px;
  width: 100%;
}

.success-header {
  display: flex;
  align-items: center;
  margin: 20px 0;
  gap: 20px;
}

.success-icon-container {
  position: relative;
  display: inline-block;
}

.icon-success {
  background: linear-gradient(135deg, #28a745, #20c997);
  box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
}

.icon-certificate {
  background: linear-gradient(135deg, #007bff, #0056b3);
  box-shadow: 0 8px 25px rgba(0, 123, 255, 0.3);
}

.success-checkmark {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 30px;
  height: 30px;
  background: #ffffff;
  border: 3px solid #28a745;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.success-checkmark i {
  color: #28a745;
  font-size: 14px;
  font-weight: bold;
}

.success-title h3 {
  margin: 0 0 5px 0;
  font-size: 28px;
  font-weight: 600;
  color: #218838;
}

.success-title .subtitle {
  margin: 0;
  font-size: 18px;
  color: #6c757d;
  font-weight: 500;
}

.success-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 35px;
}

.success-info {
  display: flex;
  flex-direction: column;
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.info-item-success {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 20px;
  background: #ffffff;
  border-radius: 10px;
  border-left: 4px solid #28a745;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.1);
  transition: all 0.3s ease;
}

.info-item-success:hover {
  transform: translateX(5px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.2);
}

.info-item-success i {
  font-size: 20px;
  flex-shrink: 0;
}

.info-item-success span {
  font-size: 16px;
  color: #495057;
  font-weight: 500;
}

.success-actions {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  padding: 25px;
  border: 1px solid #dee2e6;
}

.actions-header {
  text-align: center;
  margin-bottom: 20px;
}

.actions-header h4 {
  font-size: 20px;
  color: #2c3e50;
  font-weight: 600;
  margin: 0;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.action-item {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  cursor: pointer;
}

.action-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  border-color: #28a745;
}

.action-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #e8f5e8, #d4edda);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  transition: all 0.3s ease;
}

.action-item:hover .action-icon {
  background: linear-gradient(135deg, #28a745, #20c997);
}

.action-icon i {
  font-size: 24px;
  color: #28a745;
  transition: color 0.3s ease;
}

.action-item:hover .action-icon i {
  color: white;
}

.action-content h5 {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 8px 0;
}

.action-content p {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.4;
  margin: 0;
}

.password-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  animation: fadeInOverlay 0.3s ease;
}

@keyframes fadeInOverlay {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.password-modal {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 15px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  min-width: 400px;
  max-width: 500px;
  width: 90%;
  position: relative;
  overflow: hidden;
  animation: slideInModal 0.3s ease;
}

@keyframes slideInModal {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.password-modal::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #007bff, #28a745);
}

.modal-header {
  display: flex;
  align-items: center;
  padding: 25px 30px 20px;
  gap: 15px;
  position: relative;
}

.modal-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.modal-icon i {
  color: white;
  font-size: 22px;
}

.modal-header h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  flex: 1;
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 35px;
  height: 35px;
  border: none;
  background: rgba(108, 117, 125, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.modal-close i {
  font-size: 14px;
  color: #6c757d;
}

.modal-body {
  padding: 0 30px 8px;
}

.modal-description {
  font-size: 15px;
  color: #6c757d;
  line-height: 1.5;
  margin: 0 0 20px 0;
}

.password-input-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
}

.password-input-group input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  background: #fff;
}

.password-input-group input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.password-input-group.error input {
  border-color: #dc3545;
  background: #fff5f5;
}

.password-input-group.error input:focus {
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

.error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  color: #dc3545;
  font-size: 14px;
  font-weight: 500;
}

.error-message i {
  font-size: 14px;
}

.modal-footer {
  padding: 20px 30px 30px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.btn-cancel,
.btn-confirm {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  min-width: 120px;
  justify-content: center;
}

.btn-cancel {
  background: linear-gradient(135deg, #6c757d, #5a6268);
  color: white;
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.2);
}

.btn-cancel:hover {
  background: linear-gradient(135deg, #5a6268, #495057);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(108, 117, 125, 0.3);
}

.btn-confirm {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
}

.btn-confirm:hover:not(:disabled) {
  background: linear-gradient(135deg, #0056b3, #004085);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.3);
}

.btn-confirm:disabled {
  background: linear-gradient(135deg, #e9ecef, #dee2e6);
  color: #6c757d;
  cursor: not-allowed;
  box-shadow: none;
}

/* Estilos para selector de fecha de inicio */
.start-date-selector {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 30px;
}

.selector-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
}

.selector-header i {
  font-size: 24px;
  color: #5e72e4;
}

.selector-header h4 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.selector-info {
  margin-bottom: 25px;
}

.selector-info p {
  color: #666;
  margin-bottom: 10px;
}

.info-link {
  color: #5e72e4;
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color 0.3s ease;
}

.info-link:hover {
  color: #324cdd;
  text-decoration: underline;
}

.date-options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.date-option-card {
  background: white;
  border: 2px solid #e3e3e3;
  border-radius: 10px;
  padding: 25px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.date-option-card:hover {
  border-color: #5e72e4;
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(94, 114, 228, 0.15);
}

.card-exento:hover {
  border-color: #ffc107;
  box-shadow: 0 8px 20px rgba(255, 193, 7, 0.15);
}

.option-badge {
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.badge-enero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.badge-julio {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

.badge-exento {
  background: linear-gradient(135deg, #ffcb7e, #ff9800);
  color: white;
}

.date-option-card h5 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #2c3e50;
}

.option-description {
  color: #666;
  font-size: 14px;
  min-height: 40px;
  margin-bottom: 15px;
}

.option-footer {
  margin-top: 10px;
}

.btn-select {
  display: inline-block;
  padding: 8px 20px;
  background: linear-gradient(135deg, #17a2b8, #138496);
  color: white;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(19, 132, 150, 0.2);
}

.date-option-card:hover .btn-select {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(19, 132, 150, 0.3);
}

/* Banner de fecha seleccionada */
.selected-date-banner {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 15px;
  padding: 15px 20px;
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.banner-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.banner-content>div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.banner-content i {
  color: #28a745;
  font-size: 20px;
  line-height: 1;
}

.banner-content strong {
  margin-right: 5px;
}

.btn-change-date {
  background: transparent;
  border: 1px solid #28a745;
  color: #28a745;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-weight: 500;
  line-height: 1;
  height: auto;
  min-height: 36px;
}

.btn-change-date i {
  line-height: 1;
  display: flex;
  align-items: center;
  align-self: center;
}

.btn-change-date:hover {
  background: #28a745;
  color: white;
}

/* Seccion de exento */
.exento-info-section {
  padding: 40px 20px;
  text-align: center;
}

.exento-card {
  max-width: 600px;
  margin: 0 auto;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
}

.exento-icon {
  margin-bottom: 20px;
}

.exento-icon i {
  font-size: 60px;
}

.exento-card h3 {
  font-size: 28px;
  margin-bottom: 15px;
  font-weight: 600;
}

.exento-card>p {
  font-size: 16px;
  margin-bottom: 20px;
  opacity: 0.95;
}

.exento-details {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 15px;
  margin-top: 20px;
}

.exento-details p {
  margin: 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Modal SII */
.modal-icon-warning {
  background: linear-gradient(135deg, #ffc107, #ff9800);
}

.sii-checklist {
  list-style: none;
  padding: 0;
  margin: 20px 0;
}

.sii-checklist li {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  line-height: 1;
}

.sii-checklist i {
  color: #28a745;
  font-size: 16px;
}

.text-muted-small {
  margin: 0 auto;
  width: fit-content;
  color: #6c757d;
  font-size: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  gap: 8px;
  line-height: 1;
}

.btn-confirm-warning {
  background: linear-gradient(135deg, #ff9800, #ff9800);
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.2);
}

.btn-confirm-warning:hover:not(:disabled) {
  background: linear-gradient(135deg, #ffa620, #ffb340) !important;
  box-shadow: 0 6px 16px rgba(255, 152, 0, 0.3) !important;
}

@media (max-width: 1200px) {

  .action-column {
    margin-bottom: 0;
  }


  .certificate-content {
    align-items: center;
  }

  .action-section {
    padding: 20px;
  }

  .mobile-separator,
  #desktop-separator {
    display: block;
    height: 1px;
    background: linear-gradient(90deg, transparent, #dee2e6 20%, #dee2e6 80%, transparent);
    margin: 15px 0 10px 0;
    position: relative;
  }

  .mobile-separator::before,
  #desktop-separator::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 10px;
    border: 1px solid #dee2e6;
  }

  .mobile-separator::after,
  #desktop-separator::after {
    content: '⚙️';
    position: absolute;
    top: -11px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    background: #fff;
    padding: 2px;
    border-radius: 50%;
  }

  .certificate-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .btn-certificate {
    padding: 16px 30px;
    font-size: 17px;
    min-width: 200px;
  }

  .actions-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .btn-certificate {
    padding: 15px 28px;
    font-size: 16px;
    min-width: 180px;
  }

  #desktop-separator-step6 {
    display: block !important;
    height: 1px;
    background: linear-gradient(90deg, transparent, #dee2e6 20%, #dee2e6 80%, transparent);
    position: relative;
  }

  #desktop-separator-step6::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 10px;
    border: 1px solid #dee2e6;
  }

  #desktop-separator-step6::after {
    content: '📤';
    position: absolute;
    top: -11px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    background: #fff;
    padding: 2px;
    border-radius: 50%;
  }

}

@media (max-width: 768px) {

  .col-md-8 {
    margin-top: 15px;
  }

  .declaraciones-dropdown {
    margin-top: -8px;
    padding-bottom: 10px;
  }

  .declaraciones-dropdown .el-button {
    width: 100%;
    justify-content: center;
  }

  #certificate-upload-mobile {
    display: block !important;
    margin-bottom: 25px;
  }

  #certificate-upload-desktop {
    display: none !important;
  }

  #desktop-separator {
    display: none !important;
  }

  .mobile-separator-top,
  .mobile-separator-bottom {
    display: block;
    height: 1px;
    background: linear-gradient(90deg, transparent, #dee2e6 20%, #dee2e6 80%, transparent);
    margin: 35px 0;
    position: relative;
  }

  .mobile-separator-top::before,
  .mobile-separator-bottom::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 10px;
    border: 1px solid #dee2e6;
  }

  .mobile-separator-top::after {
    content: '📤';
    position: absolute;
    top: -11px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    background: #fff;
    padding: 2px;
    border-radius: 50%;
  }

  .mobile-separator-bottom::after {
    content: '📋';
    position: absolute;
    top: -11px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    background: #fff;
    padding: 2px;
    border-radius: 50%;
  }

  #certificate-upload-mobile .action-section {
    padding: 20px 15px;
  }

  #certificate-upload-mobile .action-column {
    margin-bottom: 0;
  }

  .instruction-section .alert {
    padding: 10px 15px;
    line-height: 1.2;
  }

  .step-1-container {
    padding: 10px;
  }

  .select-default {
    min-width: unset;
  }

  .step-4-container {
    padding: 10px;
  }

  .sii-exemption-notice {
    flex-direction: column;
    padding: 15px 18px;
    gap: 8px;
  }

  .sii-exemption-notice .notice-icon {
    width: 40px;
    height: 40px;
    align-self: center;
  }

  .sii-exemption-notice .notice-icon i {
    font-size: 18px;
  }

  .sii-exemption-notice .notice-content {
    text-align: center;
  }

  .sii-exemption-notice .notice-content h4 {
    font-size: 15px;
  }

  .sii-exemption-notice .notice-content p {
    font-size: 13px;
  }

  .certificate-info-card {
    padding: 8px;
  }

  .certificate-header {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .certificate-icon i {
    font-size: 28px;
  }

  .certificate-icon {
    width: 70px;
    height: 70px;
  }

  .certificate-title h3 {
    font-size: 24px;
  }

  .info-item {
    padding: 15px;
  }

  .action-section {
    padding: 20px;
  }

  .btn-certificate {
    padding: 15px 25px;
    font-size: 16px;
    min-width: 180px;
  }

  .upload-area {
    padding: 20px;
    min-height: 100px;
  }

  .upload-prompt i {
    font-size: 36px;
    margin-bottom: 10px;
  }

  .upload-prompt p {
    font-size: 16px;
  }

  .file-selected i {
    font-size: 48px;
  }

  .file-details {
    font-size: 14px !important;
  }

  .btn-upload {
    padding: 10px 18px;
    font-size: 16px;
  }

  .btn-upload i {
    font-size: 16px;
  }

  .help-divider span {
    padding: 6px 15px;
    font-size: 14px;
  }

  .certificate-link {
    padding: 10px 15px;
    font-size: 12px;
  }

  .certificate-link i:first-child {
    font-size: 14px;
  }

  .success-header {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .success-icon-bg {
    width: 70px;
    height: 70px;
  }

  .success-icon-bg i {
    font-size: 28px;
  }

  .success-title h3 {
    font-size: 24px;
  }

  .success-title .subtitle {
    font-size: 16px;
  }

  .actions-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .info-item-success {
    padding: 12px 15px;
  }

  .success-actions {
    padding: 20px;
  }


  .verifactu-presentation {
    padding: 20px 10px;
  }

  .presentation-header {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .presentation-title {
    font-size: 28px;
    margin: 0;
  }

  .verifactu-logo {
    max-width: 280px;
  }

  .presentation-description {
    font-size: 14px;
    padding: 15px;
  }

  .benefits-title {
    font-size: 20px;
    margin-top: 10px;
    margin-bottom: 25px;
  }

  .benefits-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .benefit-card {
    padding: 15px;
  }

  .benefit-content h4 {
    font-size: 15px;
  }

  .benefit-content p {
    font-size: 13px;
  }

  .password-modal {
    min-width: 320px;
    margin: 20px;
  }

  .modal-header {
    padding: 20px 25px 15px;
  }

  .modal-body {
    padding: 0 30px 8px;
  }

  .modal-footer {
    padding: 15px 25px 25px;
    flex-direction: column;
    gap: 8px;
  }

  .btn-cancel,
  .btn-confirm {
    width: 100%;
  }

  .selected-date-banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    padding: 18px;
  }

  .banner-content {
    width: 100%;
  }

  .banner-content>div {
    display: block;
  }

  .btn-change-date {
    width: 100%;
    justify-content: center;
    padding: 10px 16px;
  }

  .start-date-selector {
    padding: 20px 15px;
  }

  .selector-header h4 {
    font-size: 18px;
  }

  .date-options-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  #certificate-upload-desktop-step6 {
    display: block !important;
  }

}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Verifactu/VerifactuDashboard.vue